/**
 * Frontend-only analytics emitters for the product-detail surface (demo slice).
 *
 * These enqueue onto the in-memory `window.__gardenAnalyticsQueue` stub
 * (`analytics-queue.ts`); the EPIC-009 drainer is not wired yet, so nothing is
 * posted anywhere. There are deliberately NO backend catalogue/schema changes —
 * the backend `EVENT_SCHEMAS` count is asserted in tests and must not move, and
 * the queue never reaches backend validation. Props are the PII-free
 * `{ productId, sellerId }` the shared `AnalyticsEventProps` contract allows.
 */
import { enqueueAnalyticsEvent } from "@/lib/analytics-queue";

export const PRODUCT_EVENTS = {
  viewed: "marketplace.product.viewed",
  mapRevealed: "marketplace.product.map_revealed",
} as const;

/** `marketplace.product.viewed` — product-detail page mount. */
export function trackProductViewed(productId: string, sellerId: string): void {
  enqueueAnalyticsEvent(PRODUCT_EVENTS.viewed, { productId, sellerId });
}

/** `marketplace.product.map_revealed` — "Show location" CTA reveals the map. */
export function trackMapRevealed(productId: string, sellerId: string): void {
  enqueueAnalyticsEvent(PRODUCT_EVENTS.mapRevealed, { productId, sellerId });
}
